import React from 'react';
import {Tabs} from 'antd';

//引用的封装工具组件
import getSize from '../../../utils/getSize';


//各个tab页下的查询统计面板
import Xybdtj from './xybdtj';
import Xnxybdtj from './xnxybdtj';
import Zybdtj from './zybdtj';
import Bjbdtj from './bjbdtj';
import Sydbdtj from './sydbdtj';

//基础样式
import css from './index.css';
import NHFetch from "../../../utils/NHFetch";


const TabPane = Tabs.TabPane;

/**
 * @Author: yangqizhi@ly-sky.com
 * @Description: 报到统计查询面板（按登录教师当前学院进行筛选过滤）
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            success: false,
            bmid: "",
        }
    }

    componentDidMount() {
        NHFetch("/tjcx/xyxsbdtj/getBmidByLoginUserId", "GET")
          .then(res => {
              if(res && res.data && res.data.length > 0) {
                  this.setState({bmid: res.data})
              }
          }).then(()=>{this.setState({success: true})})
    }

    /**
     * * 获取tab页
     * @memberof IndexComponent
     */
    getTabPanes = () => {
        const {bmid} = this.state;

        const tabPanes = [
            <TabPane tab="学院报到统计" key="1"><Xybdtj bmid={bmid}/></TabPane>,
            <TabPane tab="校内学院报到统计" key="2"><Xnxybdtj bmid={bmid}/></TabPane>,
            <TabPane tab="专业报到统计" key="3"><Zybdtj bmid={bmid}/></TabPane>,
            <TabPane tab="班级报到统计" key="4"><Bjbdtj bmid={bmid}/></TabPane>,
            <TabPane tab="生源地报到统计" key="5"><Sydbdtj bmid={bmid}/></TabPane>,
        ];

        return tabPanes;
    };

    render() {
        return (
          this.state.success ?
          <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
              <Tabs defaultActiveKey={"2"}>
                  {this.getTabPanes()}
              </Tabs>
          </div> : null
        )
    }

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/tjcx/bdtjcxFilterByCollege/index.js